// extracted by mini-css-extract-plugin
export var column_title = "footer-module--column_title--b1440";
export var footer_background = "footer-module--footer_background--a1daf";
export var social_icon = "footer-module--social_icon--01282";